<script setup lang="ts">
import type { Group } from '~/models/Group'
import { useI18n } from 'vue-i18n'
import { faArrowRightLong } from '@fortawesome/duotone-regular-svg-icons'

const props = defineProps<{ group: Group }>()
const emit = defineEmits(['openGroup'])

const { t } = useI18n()
</script>

<template>
  <button
    class="border-green-10 hover:bg-green-10/10 text-green-5 relative flex h-full w-full items-center justify-between gap-2 rounded-xl border p-4 font-medium transition-colors focus-visible:ring"
    @click.prevent="emit('openGroup', group)"
  >
    <span
      class="relative line-clamp-2 font-semibold"
      v-text="group.name"
    />
    <font-awesome-icon
      :icon="faArrowRightLong"
      class="w-full shrink-0"
    />
  </button>
</template>
